import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { Tag } from 'src/interfaces/contractor'
import { LinkSubcontractorActionButton } from 'src/components/link-subcontractor/link-subcontractor-table/LinkSubcontractorActionButton'
import { TableTags } from 'src/components/tags/TableTags'
import { LinkableSubcontractor, LinkedSubcontractor } from 'src/interfaces/subcontractor'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { SubcontractorStatusChip } from 'src/components/link-subcontractor/shared/SubcontractorStatusChip'
import { subcontractorRequestStatusTitles } from '../subcontractorRequests/constants'

export const linkSubcontractorColumns: Array<GridColDef> = [
  {
    field: 'externalId',
    headerName: 'ID',
    flex: 2,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {params.row.id}
      </Typography>
    ),
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 2,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {`${params.row.firstName} ${params.row.lastName}`}
      </Typography>
    ),
  },

  {
    field: 'status',
    headerName: 'Status',
    flex: 2,
    sortable: true,
    valueGetter: (params: GridValueGetterParams<LinkedSubcontractor>) =>
      subcontractorRequestStatusTitles[params.row.status],
    renderCell: (params: GridRenderCellParams<LinkedSubcontractor>) => {
      return <SubcontractorStatusChip status={params.row.status} />
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 2,
    sortable: true,
  },
  {
    field: 'phone',
    headerName: 'Phone number',
    flex: 2,
    sortable: true,
  },
  {
    field: 'tags',
    headerName: 'Tag(s)',
    flex: 3,
    sortable: false,
    sortComparator: (v1: Tag[], v2: Tag[]) => {
      return v1.length - v2.length
    },
    renderCell: (params: GridRenderCellParams<LinkableSubcontractor>) =>
      params.row?.tags.length ? <TableTags tags={params.row?.tags || []} /> : <span>-</span>,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    sortable: false,
    renderCell: (params) => <LinkSubcontractorActionButton contractor={params.row} />,
  },
]

export const linkSubcontractorPageSizeOptions = [100, 250, 500, 1000]
